export const sortByAdminRating = (a, b) => {
  const aRating = a.adminRating ? Number(a.adminRating) : 0;
  const bRating = b.adminRating ? Number(b.adminRating) : 0;
  return bRating - aRating;
};
